import { Injectable } from '@angular/core';
import { Step } from '../step/models/step';
import { BackendService } from 'src/app/core/services/backend.service';
import { of, tap } from 'rxjs';

@Injectable()
export class StepCacheService {
  private _seriesStepsCache: Map<string, Step[]> = new Map<string, Step[]>();
  private _companyStepsCache: Map<string, Step[]> = new Map<string, Step[]>();

  constructor(private backendService: BackendService) {}

  public getSeriesSteps$(seriesId: string) {
    const cachedSteps = this._seriesStepsCache.get(seriesId);
    if (cachedSteps !== undefined) {
      return of(cachedSteps);
    }
    return this.backendService
      .getSeriesSteps$(seriesId)
      .pipe(tap((steps) => this._seriesStepsCache.set(seriesId, steps)));
  }

  public getCompanySteps$(companyId: string) {
    const cachedSteps = this._companyStepsCache.get(companyId);
    if (cachedSteps !== undefined) {
      return of(cachedSteps);
    }
    return this.backendService
      .getCompanySteps$(companyId)
      .pipe(tap((steps) => this._companyStepsCache.set(companyId, steps)));
  }
}
